/* Open Shopify's existing consent UI. Never grant consent or load a second banner. */
(() => {
  if (window.fcPrivacyPreferencesBound) return;
  window.fcPrivacyPreferencesBound = true;
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-privacy-preferences]');
    if (!trigger || trigger.disabled) return;
    const status = document.querySelector('[data-privacy-status]');
    const showStatus = (message) => {
      if (status) { status.textContent = message; status.hidden = !message; }
    };
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    showStatus('Datenschutzeinstellungen werden geöffnet …');
    let timer;
    try {
      // Shopify can finish loading after the footer. Bounded wait, initiated by the user.
      for (let attempt = 0; attempt < 20 && !window.privacyBanner?.showPreferences; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('unavailable');
      await Promise.race([
        window.privacyBanner.showPreferences(),
        new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('timeout')), 5000); }),
      ]);
      showStatus('');
    } catch {
      showStatus('Die Datenschutzeinstellungen konnten nicht geöffnet werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut. Ihre Auswahl wurde nicht geändert.');
    } finally {
      clearTimeout(timer);
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    }
  });
})();
